// extracted by mini-css-extract-plugin
export default {"wrapHtmlEditor":"CkEditorField__wrapHtmlEditor--s1+FF"};